import { customElement } from 'lit/decorators.js';
import { html } from 'lit';

import { bridgeToFranchiseeResource } from '../../common/franchisee-login';
import { PageBase } from './helpers/page-base';
import { router } from '../../../webmodule-common/other/router';
import { tlang } from '../../../webmodule-common/other/language/lang';

const bridgeResources = ['quotes', 'projects'];

/**
 * Landing page for the tokenless email deep link
 * /franchisee/:franchiseeId/:branchId/:resource/:resourceId (+ optional #support_ fragment for quotes).
 * The supplier is authenticated here; we mint a branch-access PAT at click time and redirect to the
 * dealer resource. See Task 229378.
 */
@customElement('app-franchisee-bridge')
export class AppFranchiseeBridge extends PageBase {
  private bridged = false;

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container">
        <p>${tlang`Opening the requested item…`}</p>
      </div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`Opening…`,
      description: tlang`Redirecting to the requested item`
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    await this.tryBridge();
  }

  protected async awaken() {
    await this.tryBridge();
    await super.awaken();
  }

  private async tryBridge() {
    if (this.bridged) return;

    const params = (router.location?.params ?? {}) as Record<string, string>;
    const franchiseeTenantId = Number(params.franchiseeId);
    const branchId = params.branchId;
    const resource = params.resource;
    const resourceId = params.resourceId;
    if (!franchiseeTenantId || !branchId || !resourceId || !bridgeResources.includes(resource)) return;

    try {
      this.bridged = true;
      await bridgeToFranchiseeResource({
        franchiseeTenantId,
        branchId,
        resource,
        resourceId,
        fragment: window.location.hash || undefined
      });
    } catch {
      // allowEnter/data may not be ready yet on this pass; let the other lifecycle hook retry.
      this.bridged = false;
    }
  }
}
